import styled from "styled-components";
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibleRows from "./visibleRows.jsx"
import { visuallyHidden } from '@mui/utils';
import {useState,useEffect} from "react"
import { estadoCuenta } from "../../../redux/actions/cuentasActions.js";
import api from '../../../axios.js';
import { useDispatch } from 'react-redux'
import SearchInputUser from "./searchInputUser.jsx"



const Container = styled.div`
	width:99%;
  display:flex;
  justify-content:center
`;

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: 'id',
  },
  {
    id: 'nombre',
    numeric: false,
    disablePadding: false,
    label: 'nombre',
  },
  {
    id: 'usuario',
    numeric: false,
    disablePadding: false,
    label: 'usuario',
  },
  {
    id: 'correo',
    numeric: false,
    disablePadding: false,
    label: 'correo',
  },
  {
    id: 'telefono',
    numeric: false,
    disablePadding: false,
    label: 'telefono',
  },
  {
    id: 'pais',
    numeric: false,
    disablePadding: false,
    label: 'pais',
  },  
  {
    id: 'tipo',
    numeric: false,
    disablePadding: false,
    label: 'tipo',
  },
  {
    id: 'fecha',
    numeric: false,
    disablePadding: false,
    label: 'fecha creacion',
  },
];


function formatFecha(fecha) {
  return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}




  function createData(user) {

    let tipo=""; 

       switch(user.tipo){
        case 1:
          tipo="superAdmin";
          break;
        case 2:
          tipo="Administrador";
          break;
        case 3:
          tipo="Cliente";
          break;
        default:

      }
 
  return {
          id:user.id,
          nombre:user.name,
          usuario:user.usuario,
          password:user.password,
          correo:user.correo,
          telefono:user.telefono,
          pais:user.pais,
          tipo:tipo,
          fecha:formatFecha(user.createdAt)
    };
}; 



function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead >
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sx={{fontSize:"14px"}}

            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}

            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align="right" sx={{fontSize:"14px"}}>agregar juegos</TableCell>
        <TableCell align="right" sx={{fontSize:"14px"}}>ver juegos</TableCell>        
      </TableRow>
    </TableHead>
  );
}

 


//---------------------------------------------------- inicio de componente--------------------------------------------------------------
export default function UsersTable(props){

  let {users,setOpen} = props;
	const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows,setRows] = useState([]);
  
  let dispatch=useDispatch();

  let deleteAccounts=async()=>{
    if(window.confirm("Desea eliminarlas cuentas selecionadas? (se eliminaran tambien los datos de juegos)")){
      dispatch(estadoCuenta(1));
      try{ 
        for(let i=0;i<selected.length;i++){         
            await api.delete(`/cuenta?id=${selected[i]}`);              
        };
        alert("cuentas eliminadas")
      }catch(err){console.log(err);alert("error al eliminar los datos")}
      dispatch(estadoCuenta(0));
    }
  };

 function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h4"
          id="tableTitle"
          component="div"
        >
          Usuarios
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon onClick={deleteAccounts} />
          </IconButton>
        </Tooltip>
      ) : (
        <SearchInputUser/>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


  useEffect(()=>{
    let rowsprops = users.map(user=>createData(user));
    setRows(rowsprops);
  },[users])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

 
	return(
		<Container style={{marginBottom:"55px",width:"100%"}}>	

			<Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer  sx={{
    maxHeight: "73vh",
    overflowY: "scroll", // Asegura que la barra aparezca solo cuando sea necesario
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#555",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#222",
    },
  }}>
          <Table
            sx={{ minWidth: "93vw" }}
            aria-labelledby="tableTitle"
            size='medium'
            stickyHeader
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              <VisibleRows rows={rows} order={order} orderBy ={orderBy} page={page} rowsPerPage={rowsPerPage}
                 selected={selected} setSelected={setSelected} setOpen={setOpen}/>

              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height:  53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
 
    </Box>
		</Container>


		)
}